var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJoined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6644 0.300575C18.0772 0.667493 18.1143 1.29957 17.7474 1.71235L7.08075 13.7123C6.89099 13.9258 6.61898 14.048 6.33334 14.048C6.04771 14.048 5.7757 13.9258 5.58593 13.7123L0.252601 7.71235C-0.114317 7.29957 -0.077136 6.66749 0.335647 6.30057C0.74843 5.93366 1.3805 5.97084 1.74742 6.38362L6.33334 11.5428L16.2526 0.38362C16.6195 -0.0291623 17.2516 -0.066343 17.6644 0.300575Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoined);
export default __webpack_public_path__ + "static/media/joined.265c585a83877ea755b3b8ffe556c904.svg";
export { ForwardRef as ReactComponent };